import type { FunctionComponent } from 'react';
import { useEffect, useState } from 'react';

import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';

// This is a timer component that counts time from game session start

export const SessionTimer: FunctionComponent = () => {
  const [timeString, setTimeString] = useState('00:00');

  useEffect(() => {
    const start = Date.now();
    setInterval(() => {
      const now = Date.now();
      const time = new Date(now - start);

      const h = time.getUTCHours();
      const m = time.getUTCMinutes();
      const s = time.getUTCSeconds();
      const mainPart = `${m > 9 ? m : '0' + m}:${s > 9 ? s : '0' + s}`;

      const result = time.getUTCHours() > 0 ? `${h > 9 ? h : '0' + h}:${mainPart}` : mainPart;

      setTimeString(result);
    }, 1000);
  }, []);

  return (
    <div data-testid="session-timer">
      <L10nText tk="SPM_SESSIONTIME_DYNAMIC" dynamicValues={[timeString]} />
    </div>
  );
};
